export enum Compliance {
  NONE = 0,
  CISv8 = 1,
  SOC2 = 2,
  ISO27001 = 3,
  GDPR = 4,
  NIS2 = 5,
  DORA = 6,
  BDCHBWINDOWS = 7,
  CMMC2 = 8,
  PCIDSSV4 = 9,
  HIPAA = 10,
}

export enum StringCompliance {
  CISv8 = 'cis-v8',
  SOC2 = 'soc-2',
  ISO27001 = 'iso-27001-2022',
  GDPR = 'gdpr',
  NIS2 = 'nis-2',
  DORA = 'dora',
  BDCHBWINDOWS = 'bdchb-windows',
  CMMC2 = 'cmmc-2',
  PCIDSSV4 = 'pci-dss-v4',
  HIPAA = 'hipaa',
}

export const ComplianceStringToEnumMapping = {
  [StringCompliance.CISv8]: Compliance.CISv8,
  [StringCompliance.SOC2]: Compliance.SOC2,
  [StringCompliance.ISO27001]: Compliance.ISO27001,
  [StringCompliance.GDPR]: Compliance.GDPR,
  [StringCompliance.NIS2]: Compliance.NIS2,
  [StringCompliance.DORA]: Compliance.DORA,
  [StringCompliance.BDCHBWINDOWS]: Compliance.BDCHBWINDOWS,
  [StringCompliance.CMMC2]: Compliance.CMMC2,
  [StringCompliance.PCIDSSV4]: Compliance.PCIDSSV4,
  [StringCompliance.HIPAA]: Compliance.HIPAA,
};

export enum ScoreLevels {
  HIGH = 60,
  MEDIUM = 30,
  LOW = 1,
}

export enum MisconfigurationType {
  BROWSER = 1,
  NETWORK = 2,
  OS = 3,
  VULNERABILITY = 4,
  CLOUD = 5,

  // KSPM subcategories
  ACCESS_CONTROL = 6,
  CONTROL_PLANE = 7,
  SECRETS = 8,
  WORKLOAD = 9,
}

export enum Status {
  COMPLIANT = 1,
  DETECTED = 2,
}

export enum State {
  ACTIVE = 1,
  IGNORED = 2,
}

export enum Watchlist {
  YES = 1,
  NO = 2,
}

export enum MitigationType {
  MANUAL = 1,
  AUTOMATIC = 2,
}

export enum LocalResourcesType {
  ENDPOINT = 1,
  SERVER = 2,
}

export enum LocalIdentitiesType {
  LOCAL = 1,
  AD = 2,
  AAD = 3,
}

export enum AffectedDeviceType {
  NOT_AFFECTED = 0,
  ENDPOINT = 1,
  SERVER = 2,

  MONITOR_ACTIVITY_LOG_ALERTS = 1000,
  AKS_MANAGED_CLUSTER = 1001,
  APPLICATION_GATEWAY_LISTENER = 1002,
  APP_SERVICE_FUNCTION_APP = 1003,
  APP_SERVICE_SITE = 1004,
  AUTHORIZATION_ROLE_DEFINITIONS = 1005,
  CACHE_REDIS = 1006,
  COMPUTE_DISKS = 1007,
  COMPUTE_VIRTUAL_MACHINES = 1008,
  CONTAINER_INSTANCE_INSTANCE = 1009,
  INSIGHTS_DIAGNOSTIC_SETTINGS = 1010,
  INSIGHTS_LOG_PROFILES = 1011,
  KEY_VAULT_KEYS = 1012,
  KEY_VAULT_VAULTS = 1013,
  MARIA_DBSERVERS = 1014,
  MYSQL_SERVERS = 1015,
  NETWORK_NETWORK_FLOW_LOGS = 1016,
  NETWORK_LOAD_BALANCERS = 1017,
  NETWORK_NETWORK_WATCHERS = 1018,
  NETWORK_PUBLIC_IPADDRESSES = 1019,
  NETWORK_VIRTUAL_NETWORKS = 1020,
  NETWORK_NETWORK_SECURITY_GROUPS = 1021,
  POSTGRESQL_SERVERS = 1022,
  RESOURCES_RESOURCE_GROUPS = 1023,
  SECURITY_AUTO_PROVISIONING_SETTINGS = 1024,
  SECURITY_PRICING = 1025,
  SECURITY_SECURITY_CONTACTS = 1026,
  SQL_DATABASES = 1027,
  SQL_SERVERS = 1028,
  STORAGE_STORAGE_ACCOUNTS = 1029,
  DOCUMENT_DBDATABASE_ACCOUNTS = 1030,
  ACMCERTIFICATE = 1031,
  AUTO_SCALING_GROUP = 1032,
  AUTO_SCALING_LAUNCH_CONFIGURATION = 1033,
  CLOUD_FRONT_DISTRIBUTION = 1034,
  CLOUD_TRAIL_TRAIL = 1035,
  CLOUD_WATCH_ALARM = 1036,
  CONFIGURATION_RECORDER = 1037,
  DYNAMO_DBTABLE = 1038,
  EBSSNAPSHOT = 1039,
  EBSVOLUME = 1040,
  ECRREPOSITORY = 1041,
  ECSCLUSTER = 1042,
  ECSCONTAINER_INSTANCE = 1043,
  ECSTASK_DEFINITION_ACTIVE = 1044,
  ECSTASK_DEFINITION_FAMILY = 1045,
  ECSSERVICE = 1046,
  EC2_AMI = 1047,
  EC2_INSTANCE = 1048,
  EC2_ELASTIC_IPADDRESS = 1049,
  EC2_NETWORK_ACL = 1050,
  EC2_SECURITY_GROUP = 1051,
  EC2_SUBNET = 1052,
  EFSFILE_SYSTEM = 1053,
  EKSCLUSTER = 1054,
  ELASTI_CACHE_CLUSTER = 1055,
  ELASTIC_BEANSTALK_ENVIRONMENT = 1056,
  ELASTIC_SEARCH_DOMAIN = 1057,
  APPLICATION_LOAD_BALANCER = 1058,
  NETWORK_LOAD_BALANCER = 1059,
  ELASTIC_LOAD_BALANCERV2 = 1060,
  CLASSIC_LOAD_BALANCER = 1061,
  GUARD_DUTY_DETECTOR = 1062,
  IAMACCESS_ANALYZER_ANALYZER = 1063,
  IAMCERTIFICATE = 1064,
  IAMIDENTITY_PROVIDER = 1065,
  IAMPASSWORD_POLICY = 1066,
  IAMPOLICY = 1067,
  KINESIS_DATA_STREAM = 1068,
  KMSKEY = 1069,
  LAMBDA_FUNCTION = 1070,
  ORGANIZATIONS_ORGANIZATION = 1071,
  RDSDBINSTANCE = 1072,
  RDSDBSNAPSHOT = 1073,
  RDSDBCLUSTER = 1074,
  REDSHIFT_CLUSTER = 1075,
  ROUTE53_HOSTED_ZONE = 1076,
  S3_BUCKET = 1077,
  SAGE_MAKER_NOTEBOOK_INSTANCE = 1078,
  SECRETS_MANAGER_SECRET = 1079,
  SNSTOPIC = 1080,
  SNSSUBSCRIPTION = 1081,
  SQSQUEUE = 1082,
  SSMPARAMETER = 1083,
  SSMSESSION = 1084,
  SSOINSTANCE = 1085,
  SSOPERMISSION_SET = 1086,
  VPCENDPOINT = 1087,
  VPCEGRESS_ONLY_INTERNET_GATEWAY = 1088,
  VPCINTERNET_GATEWAY = 1089,
  VPCVPC = 1090,
  WAFV2_ACCESS_CONTROL_LIST = 1091,
  WORK_SPACES_WORK_SPACE = 1092,
  APP_ENGINE_FIREWALL_RULE = 1093,
  BIG_QUERY_DATASET = 1094,
  BIG_QUERY_TABLE = 1095,
  CLOUD_FUNCTIONS_FUNCTION = 1096,
  CLOUD_RUN_SERVICE = 1097,
  COMPUTE_FIREWALL_RULE = 1098,
  COMPUTE_GLOBAL_BACKEND_SERVICE = 1099,
  COMPUTE_HTTPSTARGET_PROXY = 1100,
  COMPUTE_INSTANCE = 1101,
  COMPUTE_NATGATEWAY = 1102,
  COMPUTE_NETWORK = 1103,
  COMPUTE_PERSISTENT_DISK = 1104,
  COMPUTE_PROJECT = 1105,
  COMPUTE_SSLPOLICY = 1106,
  COMPUTE_SUBNET = 1107,
  COMPUTE_ZONAL_INSTANCE_GROUP = 1108,
  GKECONTAINER_CLUSTER = 1109,
  GKECONTAINER_NODE_POOL = 1110,
  DATA_PROC_CLUSTER = 1111,
  CLOUD_DNSMANAGED_ZONE = 1112,
  KMSCRYPTO_KEY = 1113,
  CLOUD_LOGGING_LOG_METRIC = 1114,
  CLOUD_LOGGING_LOG_SINK = 1115,
  CLOUD_MONITORING_ALERT_POLICY = 1116,
  PUB_SUB_TOPIC = 1117,
  PUB_SUB_SUBSCRIPTION = 1118,
  REDIS_INSTANCE = 1119,
  RESOURCE_MANAGER_PROJECT = 1120,
  SERVICE_USAGE_SERVICE = 1121,
  CLOUD_SQLINSTANCE = 1122,
  STORAGE_BUCKET = 1123,
  BIGTABLE_CLUSTER = 1124,
  EC2_ROUTE_TABLE = 1125,
  API_GATEWAY_REST_API = 1126,
  ELASTIC_LOAD_BALANCER_V2_TARGET_GROUP = 1127,
  NETWORK_VIRTUAL_NETWORKS_SUBNETS = 1128,
  NETWORK_ROUTE_TABLES = 1129,
  NETWORK_NETWORK_INTERFACES = 1130,
  EC2_NETWORK_INTERFACE = 1132,

  K8S_NAMESPACE = 2000,
  K8S_POD = 2001,
  K8S_SECRET = 2002,
  K8S_SERVICE_ACCOUNT = 2003,
  K8S_MUTATING_WEBHOOK_CONFIGURATION = 2004,
  K8S_VALIDATING_WEBHOOK_CONFIGURATION = 2005,
  K8S_DAEMON_SET = 2006,
  K8S_DEPLOYMENT = 2007,
  K8S_REPLICA_SET = 2008,
  K8S_STATEFUL_SET = 2009,
  K8S_CRON_JOB = 2010,
  K8S_JOB = 2011,
  K8S_CLUSTER_ROLE_BINDING = 2012,
  K8S_CLUSTER_ROLE = 2013,
  K8S_ROLE_BINDING = 2014,
  K8S_ROLE = 2015,
  K8S_KUBELET_INFO = 2016,
  K8S_CONTROL_PLANE_INFO = 2017,
  K8S_KUBE_PROXY_INFO = 2018,

  CONTAINER_IMAGE = 3000,
  CONTAINER = 3001,
}

export const DEVICES_TYPE = {
  ENDPOINT: 1,
  SERVER: 2,

  MONITOR_ACTIVITY_LOG_ALERTS: 1000,
  AKS_MANAGED_CLUSTER: 1001,
  APPLICATION_GATEWAY_LISTENER: 1002,
  APP_SERVICE_FUNCTION_APP: 1003,
  APP_SERVICE_SITE: 1004,
  AUTHORIZATION_ROLE_DEFINITIONS: 1005,
  CACHE_REDIS: 1006,
  COMPUTE_DISKS: 1007,
  COMPUTE_VIRTUAL_MACHINES: 1008,
  CONTAINER_INSTANCE_INSTANCE: 1009,
  INSIGHTS_DIAGNOSTIC_SETTINGS: 1010,
  INSIGHTS_LOG_PROFILES: 1011,
  KEY_VAULT_KEYS: 1012,
  KEY_VAULT_VAULTS: 1013,
  MARIA_DBSERVERS: 1014,
  MYSQL_SERVERS: 1015,
  NETWORK_NETWORK_FLOW_LOGS: 1016,
  NETWORK_LOAD_BALANCERS: 1017,
  NETWORK_NETWORK_WATCHERS: 1018,
  NETWORK_PUBLIC_IPADDRESSES: 1019,
  NETWORK_VIRTUAL_NETWORKS: 1020,
  NETWORK_NETWORK_SECURITY_GROUPS: 1021,
  POSTGRESQL_SERVERS: 1022,
  RESOURCES_RESOURCE_GROUPS: 1023,
  SECURITY_AUTO_PROVISIONING_SETTINGS: 1024,
  SECURITY_PRICING: 1025,
  SECURITY_SECURITY_CONTACTS: 1026,
  SQL_DATABASES: 1027,
  SQL_SERVERS: 1028,
  STORAGE_STORAGE_ACCOUNTS: 1029,
  DOCUMENT_DBDATABASE_ACCOUNTS: 1030,
  ACMCERTIFICATE: 1031,
  AUTO_SCALING_GROUP: 1032,
  AUTO_SCALING_LAUNCH_CONFIGURATION: 1033,
  CLOUD_FRONT_DISTRIBUTION: 1034,
  CLOUD_TRAIL_TRAIL: 1035,
  CLOUD_WATCH_ALARM: 1036,
  CONFIGURATION_RECORDER: 1037,
  DYNAMO_DBTABLE: 1038,
  EBSSNAPSHOT: 1039,
  EBSVOLUME: 1040,
  ECRREPOSITORY: 1041,
  ECSCLUSTER: 1042,
  ECSCONTAINER_INSTANCE: 1043,
  ECSTASK_DEFINITION_ACTIVE: 1044,
  ECSTASK_DEFINITION_FAMILY: 1045,
  ECSSERVICE: 1046,
  EC2_AMI: 1047,
  EC2_INSTANCE: 1048,
  EC2_ELASTIC_IPADDRESS: 1049,
  EC2_NETWORK_ACL: 1050,
  EC2_SECURITY_GROUP: 1051,
  EC2_SUBNET: 1052,
  EFSFILE_SYSTEM: 1053,
  EKSCLUSTER: 1054,
  ELASTI_CACHE_CLUSTER: 1055,
  ELASTIC_BEANSTALK_ENVIRONMENT: 1056,
  ELASTIC_SEARCH_DOMAIN: 1057,
  APPLICATION_LOAD_BALANCER: 1058,
  NETWORK_LOAD_BALANCER: 1059,
  ELASTIC_LOAD_BALANCERV2: 1060,
  CLASSIC_LOAD_BALANCER: 1061,
  GUARD_DUTY_DETECTOR: 1062,
  IAMACCESS_ANALYZER_ANALYZER: 1063,
  IAMCERTIFICATE: 1064,
  IAMIDENTITY_PROVIDER: 1065,
  IAMPASSWORD_POLICY: 1066,
  IAMPOLICY: 1067,
  KINESIS_DATA_STREAM: 1068,
  KMSKEY: 1069,
  LAMBDA_FUNCTION: 1070,
  ORGANIZATIONS_ORGANIZATION: 1071,
  RDSDBINSTANCE: 1072,
  RDSDBSNAPSHOT: 1073,
  RDSDBCLUSTER: 1074,
  REDSHIFT_CLUSTER: 1075,
  ROUTE53_HOSTED_ZONE: 1076,
  S3_BUCKET: 1077,
  SAGE_MAKER_NOTEBOOK_INSTANCE: 1078,
  SECRETS_MANAGER_SECRET: 1079,
  SNSTOPIC: 1080,
  SNSSUBSCRIPTION: 1081,
  SQSQUEUE: 1082,
  SSMPARAMETER: 1083,
  SSMSESSION: 1084,
  SSOINSTANCE: 1085,
  SSOPERMISSION_SET: 1086,
  VPCENDPOINT: 1087,
  VPCEGRESS_ONLY_INTERNET_GATEWAY: 1088,
  VPCINTERNET_GATEWAY: 1089,
  VPCVPC: 1090,
  WAFV2_ACCESS_CONTROL_LIST: 1091,
  WORK_SPACES_WORK_SPACE: 1092,
  APP_ENGINE_FIREWALL_RULE: 1093,
  BIG_QUERY_DATASET: 1094,
  BIG_QUERY_TABLE: 1095,
  CLOUD_FUNCTIONS_FUNCTION: 1096,
  CLOUD_RUN_SERVICE: 1097,
  COMPUTE_FIREWALL_RULE: 1098,
  COMPUTE_GLOBAL_BACKEND_SERVICE: 1099,
  COMPUTE_HTTPSTARGET_PROXY: 1100,
  COMPUTE_INSTANCE: 1101,
  COMPUTE_NATGATEWAY: 1102,
  COMPUTE_NETWORK: 1103,
  COMPUTE_PERSISTENT_DISK: 1104,
  COMPUTE_PROJECT: 1105,
  COMPUTE_SSLPOLICY: 1106,
  COMPUTE_SUBNET: 1107,
  COMPUTE_ZONAL_INSTANCE_GROUP: 1108,
  GKECONTAINER_CLUSTER: 1109,
  GKECONTAINER_NODE_POOL: 1110,
  DATA_PROC_CLUSTER: 1111,
  CLOUD_DNSMANAGED_ZONE: 1112,
  KMSCRYPTO_KEY: 1113,
  CLOUD_LOGGING_LOG_METRIC: 1114,
  CLOUD_LOGGING_LOG_SINK: 1115,
  CLOUD_MONITORING_ALERT_POLICY: 1116,
  PUB_SUB_TOPIC: 1117,
  PUB_SUB_SUBSCRIPTION: 1118,
  REDIS_INSTANCE: 1119,
  RESOURCE_MANAGER_PROJECT: 1120,
  SERVICE_USAGE_SERVICE: 1121,
  CLOUD_SQLINSTANCE: 1122,
  STORAGE_BUCKET: 1123,
  BIGTABLE_CLUSTER: 1124,
  EC2_ROUTE_TABLE: 1125,
  API_GATEWAY_REST_API: 1126,
  ELASTIC_LOAD_BALANCER_V2_TARGET_GROUP: 1127,
  NETWORK_VIRTUAL_NETWORKS_SUBNETS: 1128,
  NETWORK_ROUTE_TABLES: 1129,
  NETWORK_NETWORK_INTERFACES: 1130,
  EC2_NETWORK_INTERFACE: 1132,

  K8S_NAMESPACE: 2000,
  K8S_POD: 2001,
  K8S_SECRET: 2002,
  K8S_SERVICE_ACCOUNT: 2003,
  K8S_MUTATING_WEBHOOK_CONFIGURATION: 2004,
  K8S_VALIDATING_WEBHOOK_CONFIGURATION: 2005,
  K8S_DAEMON_SET: 2006,
  K8S_DEPLOYMENT: 2007,
  K8S_REPLICA_SET: 2008,
  K8S_STATEFUL_SET: 2009,
  K8S_CRON_JOB: 2010,
  K8S_JOB: 2011,
  K8S_CLUSTER_ROLE_BINDING: 2012,
  K8S_CLUSTER_ROLE: 2013,
  K8S_ROLE_BINDING: 2014,
  K8S_ROLE: 2015,
  K8S_KUBELET_INFO: 2016,
  K8S_CONTROL_PLANE_INFO: 2017,
  K8S_KUBE_PROXY_INFO: 2018,

  CONTAINER_IMAGE: 3000,
  CONTAINER: 3001,
};

export const OS_TYPE = {
  UNKNOWN: 0,
  WINDOWS: 3,
  LINUX: 4,
  MACOS: 6,
};

export enum CloudProviders {
  AWS = 1000,
  GCP = 1001,
  AZURE = 1002,
}

export const AllCloudProviders = [CloudProviders.AWS, CloudProviders.GCP, CloudProviders.AZURE];

export const OS_CLASS = new Map<number, string>([
  [OS_TYPE.WINDOWS, 'icon-windows'],
  [OS_TYPE.LINUX, 'icon-linux'],
  [OS_TYPE.MACOS, 'icon-MacOS'],

  [CloudProviders.AWS, 'icon-entity_AWS'],
  [CloudProviders.GCP, 'icon-entity_GCP'],
  [CloudProviders.AZURE, 'icon-entity_Azure'],
  
  [DEVICES_TYPE.K8S_NAMESPACE, 'icon-k8s_cluster']
]);

export enum ProviderString {
  AWS = 'aws',
  GCP = 'gcp',
  AZURE = 'azure',
  UNKNOWN = 'unknown',
}

export const PROVIDER_STR_CLASS = new Map<string, string>([
  [ProviderString.AWS, 'ds-icon-entity_AWS'],
  [ProviderString.GCP, 'ds-icon-entity_GCP'],
  [ProviderString.AZURE, 'ds-icon-entity_Azure'],
  [ProviderString.UNKNOWN, 'ds-icon-k8s_cluster'],
]);

export const DEVICES_TYPES_ORDER = [
  DEVICES_TYPE.ENDPOINT,
  DEVICES_TYPE.SERVER,

  DEVICES_TYPE.MONITOR_ACTIVITY_LOG_ALERTS,
  DEVICES_TYPE.AKS_MANAGED_CLUSTER,
  DEVICES_TYPE.APPLICATION_GATEWAY_LISTENER,
  DEVICES_TYPE.APP_SERVICE_FUNCTION_APP,
  DEVICES_TYPE.APP_SERVICE_SITE,
  DEVICES_TYPE.AUTHORIZATION_ROLE_DEFINITIONS,
  DEVICES_TYPE.CACHE_REDIS,
  DEVICES_TYPE.COMPUTE_DISKS,
  DEVICES_TYPE.COMPUTE_VIRTUAL_MACHINES,
  DEVICES_TYPE.CONTAINER_INSTANCE_INSTANCE,
  DEVICES_TYPE.INSIGHTS_DIAGNOSTIC_SETTINGS,
  DEVICES_TYPE.INSIGHTS_LOG_PROFILES,
  DEVICES_TYPE.KEY_VAULT_KEYS,
  DEVICES_TYPE.KEY_VAULT_VAULTS,
  DEVICES_TYPE.MARIA_DBSERVERS,
  DEVICES_TYPE.MYSQL_SERVERS,
  DEVICES_TYPE.NETWORK_NETWORK_FLOW_LOGS,
  DEVICES_TYPE.NETWORK_LOAD_BALANCERS,
  DEVICES_TYPE.NETWORK_NETWORK_WATCHERS,
  DEVICES_TYPE.NETWORK_PUBLIC_IPADDRESSES,
  DEVICES_TYPE.NETWORK_VIRTUAL_NETWORKS,
  DEVICES_TYPE.NETWORK_NETWORK_SECURITY_GROUPS,
  DEVICES_TYPE.POSTGRESQL_SERVERS,
  DEVICES_TYPE.RESOURCES_RESOURCE_GROUPS,
  DEVICES_TYPE.SECURITY_AUTO_PROVISIONING_SETTINGS,
  DEVICES_TYPE.SECURITY_PRICING,
  DEVICES_TYPE.SECURITY_SECURITY_CONTACTS,
  DEVICES_TYPE.SQL_DATABASES,
  DEVICES_TYPE.SQL_SERVERS,
  DEVICES_TYPE.STORAGE_STORAGE_ACCOUNTS,
  DEVICES_TYPE.DOCUMENT_DBDATABASE_ACCOUNTS,
  DEVICES_TYPE.ACMCERTIFICATE,
  DEVICES_TYPE.AUTO_SCALING_GROUP,
  DEVICES_TYPE.AUTO_SCALING_LAUNCH_CONFIGURATION,
  DEVICES_TYPE.CLOUD_FRONT_DISTRIBUTION,
  DEVICES_TYPE.CLOUD_TRAIL_TRAIL,
  DEVICES_TYPE.CLOUD_WATCH_ALARM,
  DEVICES_TYPE.CONFIGURATION_RECORDER,
  DEVICES_TYPE.DYNAMO_DBTABLE,
  DEVICES_TYPE.EBSSNAPSHOT,
  DEVICES_TYPE.EBSVOLUME,
  DEVICES_TYPE.ECRREPOSITORY,
  DEVICES_TYPE.ECSCLUSTER,
  DEVICES_TYPE.ECSCONTAINER_INSTANCE,
  DEVICES_TYPE.ECSTASK_DEFINITION_ACTIVE,
  DEVICES_TYPE.ECSTASK_DEFINITION_FAMILY,
  DEVICES_TYPE.ECSSERVICE,
  DEVICES_TYPE.EC2_AMI,
  DEVICES_TYPE.EC2_INSTANCE,
  DEVICES_TYPE.EC2_ELASTIC_IPADDRESS,
  DEVICES_TYPE.EC2_NETWORK_ACL,
  DEVICES_TYPE.EC2_SECURITY_GROUP,
  DEVICES_TYPE.EC2_SUBNET,
  DEVICES_TYPE.EFSFILE_SYSTEM,
  DEVICES_TYPE.EKSCLUSTER,
  DEVICES_TYPE.ELASTI_CACHE_CLUSTER,
  DEVICES_TYPE.ELASTIC_BEANSTALK_ENVIRONMENT,
  DEVICES_TYPE.ELASTIC_SEARCH_DOMAIN,
  DEVICES_TYPE.APPLICATION_LOAD_BALANCER,
  DEVICES_TYPE.NETWORK_LOAD_BALANCER,
  DEVICES_TYPE.ELASTIC_LOAD_BALANCERV2,
  DEVICES_TYPE.CLASSIC_LOAD_BALANCER,
  DEVICES_TYPE.GUARD_DUTY_DETECTOR,
  DEVICES_TYPE.IAMACCESS_ANALYZER_ANALYZER,
  DEVICES_TYPE.IAMCERTIFICATE,
  DEVICES_TYPE.IAMIDENTITY_PROVIDER,
  DEVICES_TYPE.IAMPASSWORD_POLICY,
  DEVICES_TYPE.IAMPOLICY,
  DEVICES_TYPE.KINESIS_DATA_STREAM,
  DEVICES_TYPE.KMSKEY,
  DEVICES_TYPE.LAMBDA_FUNCTION,
  DEVICES_TYPE.ORGANIZATIONS_ORGANIZATION,
  DEVICES_TYPE.RDSDBINSTANCE,
  DEVICES_TYPE.RDSDBSNAPSHOT,
  DEVICES_TYPE.RDSDBCLUSTER,
  DEVICES_TYPE.REDSHIFT_CLUSTER,
  DEVICES_TYPE.ROUTE53_HOSTED_ZONE,
  DEVICES_TYPE.S3_BUCKET,
  DEVICES_TYPE.SAGE_MAKER_NOTEBOOK_INSTANCE,
  DEVICES_TYPE.SECRETS_MANAGER_SECRET,
  DEVICES_TYPE.SNSTOPIC,
  DEVICES_TYPE.SNSSUBSCRIPTION,
  DEVICES_TYPE.SQSQUEUE,
  DEVICES_TYPE.SSMPARAMETER,
  DEVICES_TYPE.SSMSESSION,
  DEVICES_TYPE.SSOINSTANCE,
  DEVICES_TYPE.SSOPERMISSION_SET,
  DEVICES_TYPE.VPCENDPOINT,
  DEVICES_TYPE.VPCEGRESS_ONLY_INTERNET_GATEWAY,
  DEVICES_TYPE.VPCINTERNET_GATEWAY,
  DEVICES_TYPE.VPCVPC,
  DEVICES_TYPE.WAFV2_ACCESS_CONTROL_LIST,
  DEVICES_TYPE.WORK_SPACES_WORK_SPACE,
  DEVICES_TYPE.APP_ENGINE_FIREWALL_RULE,
  DEVICES_TYPE.BIG_QUERY_DATASET,
  DEVICES_TYPE.BIG_QUERY_TABLE,
  DEVICES_TYPE.CLOUD_FUNCTIONS_FUNCTION,
  DEVICES_TYPE.CLOUD_RUN_SERVICE,
  DEVICES_TYPE.COMPUTE_FIREWALL_RULE,
  DEVICES_TYPE.COMPUTE_GLOBAL_BACKEND_SERVICE,
  DEVICES_TYPE.COMPUTE_HTTPSTARGET_PROXY,
  DEVICES_TYPE.COMPUTE_INSTANCE,
  DEVICES_TYPE.COMPUTE_NATGATEWAY,
  DEVICES_TYPE.COMPUTE_NETWORK,
  DEVICES_TYPE.COMPUTE_PERSISTENT_DISK,
  DEVICES_TYPE.COMPUTE_PROJECT,
  DEVICES_TYPE.COMPUTE_SSLPOLICY,
  DEVICES_TYPE.COMPUTE_SUBNET,
  DEVICES_TYPE.COMPUTE_ZONAL_INSTANCE_GROUP,
  DEVICES_TYPE.GKECONTAINER_CLUSTER,
  DEVICES_TYPE.GKECONTAINER_NODE_POOL,
  DEVICES_TYPE.DATA_PROC_CLUSTER,
  DEVICES_TYPE.CLOUD_DNSMANAGED_ZONE,
  DEVICES_TYPE.KMSCRYPTO_KEY,
  DEVICES_TYPE.CLOUD_LOGGING_LOG_METRIC,
  DEVICES_TYPE.CLOUD_LOGGING_LOG_SINK,
  DEVICES_TYPE.CLOUD_MONITORING_ALERT_POLICY,
  DEVICES_TYPE.PUB_SUB_TOPIC,
  DEVICES_TYPE.PUB_SUB_SUBSCRIPTION,
  DEVICES_TYPE.REDIS_INSTANCE,
  DEVICES_TYPE.RESOURCE_MANAGER_PROJECT,
  DEVICES_TYPE.SERVICE_USAGE_SERVICE,
  DEVICES_TYPE.CLOUD_SQLINSTANCE,
  DEVICES_TYPE.STORAGE_BUCKET,
  DEVICES_TYPE.BIGTABLE_CLUSTER,
  DEVICES_TYPE.EC2_ROUTE_TABLE,
  DEVICES_TYPE.API_GATEWAY_REST_API,
  DEVICES_TYPE.ELASTIC_LOAD_BALANCER_V2_TARGET_GROUP,
  DEVICES_TYPE.NETWORK_VIRTUAL_NETWORKS_SUBNETS,
  DEVICES_TYPE.NETWORK_ROUTE_TABLES,
  DEVICES_TYPE.NETWORK_NETWORK_INTERFACES,
  DEVICES_TYPE.EC2_NETWORK_INTERFACE,
  DEVICES_TYPE.K8S_NAMESPACE,
  DEVICES_TYPE.K8S_POD,
  DEVICES_TYPE.K8S_SECRET,
  DEVICES_TYPE.K8S_SERVICE_ACCOUNT,
  DEVICES_TYPE.K8S_MUTATING_WEBHOOK_CONFIGURATION,
  DEVICES_TYPE.K8S_VALIDATING_WEBHOOK_CONFIGURATION,
  DEVICES_TYPE.K8S_DAEMON_SET,
  DEVICES_TYPE.K8S_DEPLOYMENT,
  DEVICES_TYPE.K8S_REPLICA_SET,
  DEVICES_TYPE.K8S_STATEFUL_SET,
  DEVICES_TYPE.K8S_CRON_JOB,
  DEVICES_TYPE.K8S_JOB,
  DEVICES_TYPE.K8S_CLUSTER_ROLE_BINDING,
  DEVICES_TYPE.K8S_CLUSTER_ROLE,
  DEVICES_TYPE.K8S_ROLE_BINDING,
  DEVICES_TYPE.K8S_ROLE,
  DEVICES_TYPE.K8S_KUBELET_INFO,
  DEVICES_TYPE.K8S_CONTROL_PLANE_INFO,
  DEVICES_TYPE.K8S_KUBE_PROXY_INFO,
  DEVICES_TYPE.CONTAINER_IMAGE,
  DEVICES_TYPE.CONTAINER,
];

export const DEVICES_CLASS = new Map<number, string>([
  [DEVICES_TYPE.ENDPOINT, 'ds-icon-entity_endpoint'],
  [DEVICES_TYPE.SERVER, 'ds-icon-entity_server'],

  // Azure icons
  [DEVICES_TYPE.MONITOR_ACTIVITY_LOG_ALERTS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.AKS_MANAGED_CLUSTER, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.APPLICATION_GATEWAY_LISTENER, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.APP_SERVICE_FUNCTION_APP, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.APP_SERVICE_SITE, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.AUTHORIZATION_ROLE_DEFINITIONS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.CACHE_REDIS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.COMPUTE_DISKS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.COMPUTE_VIRTUAL_MACHINES, 'ds-icon-entity_virtual_server_Azure'],
  [DEVICES_TYPE.CONTAINER_INSTANCE_INSTANCE, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.INSIGHTS_DIAGNOSTIC_SETTINGS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.INSIGHTS_LOG_PROFILES, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.KEY_VAULT_KEYS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.KEY_VAULT_VAULTS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.MARIA_DBSERVERS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.MYSQL_SERVERS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.NETWORK_NETWORK_FLOW_LOGS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.NETWORK_LOAD_BALANCERS, 'ds-icon-entity_load_balancer_Azure'],
  [DEVICES_TYPE.NETWORK_NETWORK_WATCHERS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.NETWORK_PUBLIC_IPADDRESSES, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.NETWORK_VIRTUAL_NETWORKS, 'ds-icon-entity_virtual_network_Azure'],
  [DEVICES_TYPE.NETWORK_NETWORK_SECURITY_GROUPS, 'ds-icon-entity_security_group_Azure'],
  [DEVICES_TYPE.POSTGRESQL_SERVERS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.RESOURCES_RESOURCE_GROUPS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.SECURITY_AUTO_PROVISIONING_SETTINGS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.SECURITY_PRICING, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.SECURITY_SECURITY_CONTACTS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.SQL_DATABASES, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.SQL_SERVERS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.STORAGE_STORAGE_ACCOUNTS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.DOCUMENT_DBDATABASE_ACCOUNTS, 'ds-icon-Azure_resource_type'],
  [DEVICES_TYPE.NETWORK_VIRTUAL_NETWORKS_SUBNETS, 'ds-icon-entity_subnet_Azure'],
  [DEVICES_TYPE.NETWORK_ROUTE_TABLES, 'ds-icon-entity_network_route_table_Azure'],
  [DEVICES_TYPE.NETWORK_NETWORK_INTERFACES, 'ds-icon-entity_network_interface_Azure'],

  // AWS icons
  [DEVICES_TYPE.ACMCERTIFICATE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.AUTO_SCALING_GROUP, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.AUTO_SCALING_LAUNCH_CONFIGURATION, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.CLOUD_FRONT_DISTRIBUTION, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.CLOUD_TRAIL_TRAIL, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.CLOUD_WATCH_ALARM, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.CONFIGURATION_RECORDER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.DYNAMO_DBTABLE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EBSSNAPSHOT, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EBSVOLUME, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ECRREPOSITORY, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ECSCLUSTER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ECSCONTAINER_INSTANCE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ECSTASK_DEFINITION_ACTIVE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ECSTASK_DEFINITION_FAMILY, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ECSSERVICE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EC2_AMI, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EC2_INSTANCE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EC2_ELASTIC_IPADDRESS, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EC2_NETWORK_ACL, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EC2_SECURITY_GROUP, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EC2_SUBNET, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EFSFILE_SYSTEM, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EKSCLUSTER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ELASTI_CACHE_CLUSTER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ELASTIC_BEANSTALK_ENVIRONMENT, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ELASTIC_SEARCH_DOMAIN, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.APPLICATION_LOAD_BALANCER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.NETWORK_LOAD_BALANCER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ELASTIC_LOAD_BALANCERV2, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.CLASSIC_LOAD_BALANCER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.GUARD_DUTY_DETECTOR, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.IAMACCESS_ANALYZER_ANALYZER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.IAMCERTIFICATE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.IAMIDENTITY_PROVIDER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.IAMPASSWORD_POLICY, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.IAMPOLICY, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.KINESIS_DATA_STREAM, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.KMSKEY, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.LAMBDA_FUNCTION, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ORGANIZATIONS_ORGANIZATION, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.RDSDBINSTANCE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.RDSDBSNAPSHOT, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.RDSDBCLUSTER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.REDSHIFT_CLUSTER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ROUTE53_HOSTED_ZONE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.S3_BUCKET, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.SAGE_MAKER_NOTEBOOK_INSTANCE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.SECRETS_MANAGER_SECRET, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.SNSTOPIC, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.SNSSUBSCRIPTION, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.SQSQUEUE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.SSMPARAMETER, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.SSMSESSION, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.SSOINSTANCE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.SSOPERMISSION_SET, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.VPCENDPOINT, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.VPCEGRESS_ONLY_INTERNET_GATEWAY, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.VPCINTERNET_GATEWAY, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.VPCVPC, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.WAFV2_ACCESS_CONTROL_LIST, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.WORK_SPACES_WORK_SPACE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.API_GATEWAY_REST_API, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.ELASTIC_LOAD_BALANCER_V2_TARGET_GROUP, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EC2_ROUTE_TABLE, 'ds-icon-AWS_resource_type'],
  [DEVICES_TYPE.EC2_NETWORK_INTERFACE, 'ds-icon-AWS_resource_type'],

  // GCP icons
  [DEVICES_TYPE.APP_ENGINE_FIREWALL_RULE, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.BIG_QUERY_DATASET, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.BIG_QUERY_TABLE, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.CLOUD_FUNCTIONS_FUNCTION, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.CLOUD_RUN_SERVICE, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_FIREWALL_RULE, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_GLOBAL_BACKEND_SERVICE, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_HTTPSTARGET_PROXY, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_INSTANCE, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_NATGATEWAY, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_NETWORK, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_PERSISTENT_DISK, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_PROJECT, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_SSLPOLICY, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_SUBNET, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.COMPUTE_ZONAL_INSTANCE_GROUP, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.GKECONTAINER_CLUSTER, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.GKECONTAINER_NODE_POOL, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.DATA_PROC_CLUSTER, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.CLOUD_DNSMANAGED_ZONE, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.KMSCRYPTO_KEY, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.CLOUD_LOGGING_LOG_METRIC, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.CLOUD_LOGGING_LOG_SINK, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.CLOUD_MONITORING_ALERT_POLICY, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.PUB_SUB_TOPIC, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.PUB_SUB_SUBSCRIPTION, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.REDIS_INSTANCE, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.RESOURCE_MANAGER_PROJECT, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.SERVICE_USAGE_SERVICE, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.CLOUD_SQLINSTANCE, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.STORAGE_BUCKET, 'ds-icon-GCP_resource_type'],
  [DEVICES_TYPE.BIGTABLE_CLUSTER, 'ds-icon-GCP_resource_type'],

  // KSPM icons
  [DEVICES_TYPE.K8S_NAMESPACE, 'ds-icon-k8s_management'],
  [DEVICES_TYPE.K8S_POD, 'ds-icon-k8s_workload'],
  [DEVICES_TYPE.K8S_SECRET, 'ds-icon-k8s_configuration'],
  [DEVICES_TYPE.K8S_SERVICE_ACCOUNT, 'ds-icon-k8s_security'],
  [DEVICES_TYPE.K8S_MUTATING_WEBHOOK_CONFIGURATION, 'ds-icon-k8s_workload'],
  [DEVICES_TYPE.K8S_VALIDATING_WEBHOOK_CONFIGURATION, 'ds-icon-k8s_workload'],
  [DEVICES_TYPE.K8S_DAEMON_SET, 'ds-icon-k8s_workload'],
  [DEVICES_TYPE.K8S_DEPLOYMENT, 'ds-icon-k8s_workload'],
  [DEVICES_TYPE.K8S_REPLICA_SET, 'ds-icon-k8s_workload'],
  [DEVICES_TYPE.K8S_STATEFUL_SET, 'ds-icon-k8s_workload'],
  [DEVICES_TYPE.K8S_CRON_JOB, 'ds-icon-k8s_workload'],
  [DEVICES_TYPE.K8S_JOB, 'ds-icon-k8s_workload'],
  [DEVICES_TYPE.K8S_CLUSTER_ROLE_BINDING, 'ds-icon-k8s_security'],
  [DEVICES_TYPE.K8S_CLUSTER_ROLE, 'ds-icon-k8s_security'],
  [DEVICES_TYPE.K8S_ROLE_BINDING, 'ds-icon-k8s_security'],
  [DEVICES_TYPE.K8S_ROLE, 'ds-icon-k8s_security'],
  [DEVICES_TYPE.K8S_KUBELET_INFO, 'ds-icon-k8s_custom'],
  [DEVICES_TYPE.K8S_CONTROL_PLANE_INFO, 'ds-icon-k8s_custom'],
  [DEVICES_TYPE.K8S_KUBE_PROXY_INFO, 'ds-icon-k8s_custom'],

  // Container image icons
  [DEVICES_TYPE.CONTAINER_IMAGE, 'ds-icon-container_image'],
  [DEVICES_TYPE.CONTAINER, 'ds-icon-container_filled'],
]);

export enum Categories {
  MISCONFIGURATION = 'misconfiguration',
  HUMAN_BASED_RISK = 'human based risk',
}

export enum Actions {
  IGNORE_MISCONFIGURATIONS = 1,
  RESTORE_MISCONFIGURATIONS = 2,
  IGNORE_APPLICATIONS = 3,
  RESTORE_APPLICATIONS = 4,
  IGNORE_HUMAN_RISKS = 5,
  RESTORE_HUMAN_RISKS = 6,
  IGNORE_DEVICES = 7,
  RESTORE_DEVICES = 8,
  IGNORE_USERS = 9,
  RESTORE_USERS = 10,
  FIX_MISCONFIGURATIONS = 11,
  INSTALL_PATCH = 12,
  ISOLATE_DEVICE = 13,
  SCAN = 14,
  ROLLBACK_FIXES = 15,
}

export enum ActionsEvents {
  WATCHLIST_CHANGED = 'watchlist-changed',
}

export enum ActionsColumnValues {
  ADD_TO_WATCHLIST,
  REMOVE_FROM_WATCHLIST,
  IGNORE,
  RESTORE,
  FIX_RISK,
  ISOLATE_DEVICE = 5,
  ROLLBACK_FIX = 6,
}

export const FULFILLED_PROMISE_STATUS = 'fulfilled';

export enum IsolationStatus {
  ISOLATION_STATUS_ISOLATED = 1,
  ISOLATION_STATUS_NOT_ISOLATED = 2,
  ISOLATION_STATUS_PENDING_ISOLATION = 3,
  ISOLATION_STATUS_PENDING_RESTORE = 4,
}

export enum AppIds {
  APPID_UNIFIED_CLIENT = 12,
  APPID_MAC_CLIENT = 61,
}

export enum FindingsDetailsItemsType {
  GENERIC = 0,
  PATHS = 1,
  REGISTRIES = 2,
  HOSTS = 3,
  SHARED_PASSWORDS = 4,
  DETECTIONS = 5,
  PACKAGES = 6,
}

export enum DetailsType {
  VULNERABILITIES = 1,
  MISCONFIGURATION = 2,
}

export enum RiskTypes {
  MISCONFIGURATIONS = 'findings',
  DEVICES = 'resources',
  USER_BEHAVIOUR_RISKS = 'identity-risks',
  USERS = 'identities',
  VULNERABILITIES = 'vulnerabilities',
}

export enum ScoreTypes {
  ENDPOINTS_SCORE = 'endpoints',
  INDUSTRY_SCORE = 'industry',
  EXPLOITABILITY_SCORE = 'exploitabilityScore',
  CVES_COUNT_SCORE = 'cvesCountScore',
  APPLICATIONS_SCORE = 'applications',
  USERS_SCORE = 'users',
}

export enum ChangeStateBulkValues {
  IGNORE = 1,
  RESTORE = 2,
}

export enum ChangeWatchlistBulkValues {
  ADD_TO_WATCHLIST = 1,
  REMOVE_FROM_WATCHLIST = 2,
}

export enum FixStateBulkValues {
  FIX_RISKS = 1,
  ROLLBACK_FIXES = 2,
}

export enum InlineMenuExtraDetailsSelectEvents {
  copyToClipboard = 'copyToClipboard',
  viewIncidents = 'viewIncidentsExtraDetails',
  viewEvents = 'viewEventsExtraDetails',
}

export const CVE_SIDE_PANEL_SHOW_LIMIT = 100;
export const CVE_SIDE_PANEL_SHOW_INCREMENT = 100;

export enum FixRisksErrorCodes {
  SUCCESS = 0,
  FAILED = 1,
}

export enum RollbackRisksErrorCodes {
  SUCCESS = 0,
  ROLLBACK_CORRUPTED = 1,
  FAILED = 2,
  ROLLBACK_NOT_FOUND = 3,
  ROLLBACK_CHANGED_STATE = 4,
}

export enum SelectionEvents {
  RESOURCE_ICON_CLICK = 'resource-icon-click',
  IDENTITY_ICON_CLICK = 'identity-icon-click',
}

export enum DropdownActionsSelection {
  VIEW_RESOURCE = 1,
  VIEW_INCIDENTS = 2,
  VIEW_IDENTITY = 3,
}

export enum CSV_TYPE {
  NORMAL = 'normal',
  BREAKDOWN = 'breakdown',
}
